export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7088.37c165be.jpg";